import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Announcement from "../components/Announcement";
import { Chair, KeyboardDoubleArrowDown } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { portfolioItems } from "../data";
import ImageSlider from "../components/ImageSlider";
import { useMediaQuery } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const ProductDetails = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");
  const { productId, id } = useParams();
  const [activeComponent, setActiveComponent] = useState("");
  const [showScrollDown, setShowScrollDown] = useState(false);
  const [isBottomScreen, setIsBottomScreen] = useState(false);
  const portfolioDetails = portfolioItems
    ?.find((item) => item.id === Number(productId))
    ?.portfolioInfo.find((item) => item.id === Number(id));
  let hideTimeout;

  window.onpopstate = () => {
    navigate("/#portfolios");
  };

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveComponent(entry.target.id);
          if (entry.target.id === "imageSlider") {
            setShowScrollDown(false);
            setIsBottomScreen(true);
          } else {
            showScrollIndicator();
          }
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    const components = [
      "ProductDetailCover",
      "ProductDetailDetail",
      "imageSlider",
    ];

    components.forEach((id) => {
      const ref = document.getElementById(id);
      if (ref) {
        observer.observe(ref);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollIconBackgroundColor =
    activeComponent === "ProductDetailDetail" ? "black" : "#f5fbfd";

  const scrollIconColor =
    activeComponent === "ProductDetailDetail" ? "white" : "black";

  const showScrollIndicator = () => {
    if (isBottomScreen) {
      return null;
    } else {
      setShowScrollDown(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setShowScrollDown(false);
      }, 2000);
    }
  };

  useEffect(() => {
    const handleMouseMove = () => {
      showScrollIndicator();
    };

    const handleTouchStart = () => {
      showScrollIndicator();
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchstart", handleTouchStart);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchstart", handleTouchStart);
      clearTimeout(hideTimeout);
    };
  }, [isBottomScreen]);

  const handleWhatsappClick = () => {
    window.location.href = "https://wa.link/hj33t3";
  };

  return (
    <Container>
      <StickyHeader>
        {/* <Announcement /> */}
        <Navbar activeMenuItem={activeComponent} isOtherScreen={true} />
      </StickyHeader>
      {isMobile && (
        <LeftArrowIcon>
          <KeyboardBackspaceIcon
            style={{ fontSize: 24 }}
            onClick={() => {
              navigate("/#portfolios");
            }}
          />
        </LeftArrowIcon>
      )}
      <ProductContainer>
        <VideoContainer id="ProductDetailCover">
          <Image
            src={`/img/${portfolioDetails.image}`}
            alt={portfolioDetails.title}
          />
          <TitleContainer>
            <Title>{portfolioDetails.title}</Title>
            <SubTitle>{portfolioDetails.subTitle}</SubTitle>
          </TitleContainer>
        </VideoContainer>

        <ProductContentContainer id="ProductDetailDetail">
          <MainImageContainer>
            <LeftImageContainer>
              {portfolioDetails.imageOne && (
                <PrimaryImage
                  src={`/img/portfolios/${portfolioDetails.imageOne}`}
                />
              )}

              <HorizontalImageContainer>
                {portfolioDetails.imageTwo && (
                  <TertiaryImage
                    src={`/img/portfolios/${portfolioDetails.imageTwo}`}
                  />
                )}
                {portfolioDetails.imageThree && (
                  <TertiaryImage
                    src={`/img/portfolios/${portfolioDetails.imageThree}`}
                  />
                )}
              </HorizontalImageContainer>
            </LeftImageContainer>

            <VerticalImageList>
              {portfolioDetails.imageFour && (
                <SecondaryImage
                  src={`/img/portfolios/${portfolioDetails.imageFour}`}
                />
              )}
              {portfolioDetails.imageFive && (
                <SecondaryImage
                  src={`/img/portfolios/${portfolioDetails.imageFive}`}
                />
              )}
              {portfolioDetails.imageSix && (
                <SecondaryImage
                  src={`/img/portfolios/${portfolioDetails.imageSix}`}
                />
              )}
            </VerticalImageList>
          </MainImageContainer>
          <ProductDetailContainer>
            <ProductTitleContainer>
              <ProductTitle>{portfolioDetails.portfolioName}</ProductTitle>
            </ProductTitleContainer>
            <ProductDetailContent>
              {/* <ProductTypeView> */}
              <ProductTypeContainer>
                <ProductTypeDetails>
                  <ProductLabel>Project Name</ProductLabel>
                  <ProductInfo>{portfolioDetails.name}</ProductInfo>
                </ProductTypeDetails>
                <ProductTypeDetails>
                  <ProductLabel>Property</ProductLabel>
                  <ProductInfo>{portfolioDetails.type}</ProductInfo>
                </ProductTypeDetails>
                <ProductTypeDetails>
                  <ProductLabel>Service Category</ProductLabel>
                  <ProductInfo>{portfolioDetails.service}</ProductInfo>
                </ProductTypeDetails>
                <ProductTypeDetails>
                  <ProductLabel>Location</ProductLabel>
                  <ProductInfo>{portfolioDetails.location}</ProductInfo>
                </ProductTypeDetails>
              </ProductTypeContainer>
              {/* </ProductTypeView> */}
              {/* Todo: Complete Icon type */}
              {/* <ProductIncludedServicesContainer>
                <IncludedServicesTitle>Services</IncludedServicesTitle>
                <IncludedServicesContainer>
                  <ServicesContainer>
                    <Chair />
                    <ServicesLabel>Furniture</ServicesLabel>
                  </ServicesContainer>
                  <ServicesContainer>
                    <Chair />
                    <ServicesLabel>Furniture</ServicesLabel>
                  </ServicesContainer>
                  <ServicesContainer>
                    <Chair />
                    <ServicesLabel>Furniture</ServicesLabel>
                  </ServicesContainer>
                  <ServicesContainer>
                    <Chair />
                    <ServicesLabel>Furniture</ServicesLabel>
                  </ServicesContainer>
                </IncludedServicesContainer>
              </ProductIncludedServicesContainer> */}
            </ProductDetailContent>
          </ProductDetailContainer>
        </ProductContentContainer>
        <ImageSlider imageList={portfolioDetails.secondaryImageList} />
      </ProductContainer>
      {showScrollDown && (
        <ScrollDownIcon>
          <ScrollDown backgroundColor={scrollIconBackgroundColor}>
            <KeyboardDoubleArrowDown htmlColor={scrollIconColor} />
          </ScrollDown>
          <ScrollDownLabel fontColor={scrollIconBackgroundColor}>
            Scroll down
          </ScrollDownLabel>
        </ScrollDownIcon>
      )}
      <WhatsappContainer onClick={handleWhatsappClick}>
        <WhatsappIcon src="/whatsappIcon.svg" />
      </WhatsappContainer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
`;

const StickyHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 3;
`;

const LeftArrowIcon = styled.div`
  position: absolute;
  left: 7px;
  top: 35px;
  z-index: 3;
`;

const ProductContainer = styled.div`
  height: 100vh;
  width: 100%;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: inherit;
  scroll-behavior: smooth;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const VideoContainer = styled.div`
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 1);
  overflow: hidden;
  scroll-snap-align: center;
  align-items: center;
`;

const Video = styled.video`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.6;
`;

const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.6;
`;

const TitleContainer = styled.div`
  position: relative;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
`;

const Title = styled.h1`
  font-size: 75px;
  letter-spacing: 5px;
  text-align: center;
  color: white;
  font-family: "Kestrel";
  @media (max-width: 768px) {
    font-size: 45px;
    letter-spacing: 2px;
  }
`;

const SubTitle = styled.p`
  margin-top: 10px;
  font-size: 25px;
  font-weight: 500;
  text-align: center;
  color: white;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ProductContentContainer = styled.div`
  height: 100vh;
  scroll-snap-align: center;
  position: relative;
  display: flex;
  background-color: #f5fbfd;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MainImageContainer = styled.div`
  height: 90vh;
  width: 57%;
  display: flex;
  column-gap: 5px;
  padding: 8vh 20px 0 20px;
  @media (max-width: 768px) {
    height: 50vh;
    width: 100%;
    padding: 60px 0px 0 0px;
    /* background-color: blue; */
  }
`;

const LeftImageContainer = styled.div`
  height: 100%;
  width: 80%;
`;

const PrimaryImage = styled.img`
  object-fit: fill;
  position: relative;
  height: 66.5%;
  width: 100%;
  @media (max-width: 768px) {
    height: 19vh;
  }
`;

const HorizontalImageContainer = styled.div`
  height: 33%;
  width: 100%;
  display: flex;
  column-gap: 5px;
  @media (max-width: 768px) {
    height: 12vh;
  }
`;

const SecondaryImage = styled.img`
  object-fit: fill;
  height: 100%;
  width: 100%;
  display: inline-block;
  @media (max-width: 768px) {
    height: 10.1vh;
  }
  @media (min-width: 1600px) {
    max-height: 29.6vh;
  }
`;

const VerticalImageList = styled.div`
  height: 100%;
  width: 35%;
  display: grid;
  row-gap: 5px;
  @media (max-width: 768px) {
    height: 19vh;
  }
`;

const TertiaryImage = styled.img`
  object-fit: fill;
  height: 100%;
  width: 49.6%;
  display: inline-block;
  @media (max-width: 768px) {
    width: 49.2%;
  }
`;

const ProductDetailContainer = styled.div`
  height: 92vh;
  width: 43%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6vh 20px 0 0px;
  justify-content: space-between;
  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
    padding: 0px 0px 0px 0px;
  }
`;

const ProductTitleContainer = styled.div`
  @media (max-width: 768px) {
    height: 50%;
    align-items: center;
    display: flex;
    /* background-color: red; */
  }
`;

const ProductTitle = styled.h3`
  /* height: 25%; */
  font-family: "Kestrel";
  font-size: 75px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 40px;
    text-align: left;
    margin-left: 20px;
  }
`;

const ProductDetailContent = styled.div`
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: lightgray;
  @media (max-width: 768px) {
    padding-top: 10px;
    height: 260px;
  }
`;

const ProductTypeContainer = styled.div`
  flex-direction: column;
  display: flex;
  padding: 30px;
  row-gap: 25px;
  @media (max-width: 768px) {
    padding: 10px;
    row-gap: 10px;
  }
`;

const ProductTypeDetails = styled.div`
  max-width: 100%;
  flex-direction: column;
  row-gap: 5px;
  display: flex;
  @media (max-width: 768px) {
    row-gap: 2px;
  }
`;

const ProductLabel = styled.p`
  font-size: 18px;
  color: slategray;
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const ProductInfo = styled.p`
  font-size: 18px;
  @media (max-width: 768px) {
    font-size: 13px;
    font-weight: bold;
  }
`;

const ProductIncludedServicesContainer = styled.p`
  height: 30%;
  display: flex;
  flex-direction: column;
  padding: 0 30px 0 30px;
  @media (max-width: 768px) {
    padding: 0 10px 0 10px;
  }
`;

const IncludedServicesTitle = styled.h1`
  font-size: 22px;
  margin-top: 10px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const IncludedServicesContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex;
  align-items: flex-start;
  gap: 25px;
  @media (max-width: 768px) {
    gap: 15px;
  }
`;

const ServicesContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 5px;
  align-items: center;
`;

const ServicesLabel = styled.p`
  font-size: 12;
`;

const ImageContainer = styled.div`
  height: 100vh;
  width: 100%;
  overflow: hidden;
  scroll-snap-align: center;
  /* z-index: 5; */
`;

const InfoContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  /* z-index: 5; */
`;

const PortfolioTitle = styled.h1`
  font-size: 65px;
  letter-spacing: 5px;
  text-align: center;
  color: white;
`;

const ScrollDownIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 10px;
  left: 48%;
  @media (max-width: 768px) {
    left: 42%;
  }
`;

const ScrollDown = styled.div`
  background-color: ${(props) => props.backgroundColor};
  padding: 5px;
  border-radius: 50%;
  display: flex;
`;

const ScrollDownLabel = styled.p`
  font-size: 14px;
  margin-top: 5px;
  color: ${(props) => props.fontColor};
`;

const WhatsappContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 5;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    bottom: 40px;
    right: 15px;
  }
`;

const WhatsappIcon = styled.img`
  display: flex;
  height: 50px;
  width: 50px;
  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
`;

export default ProductDetails;
